import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "BrowseFilled"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_1428_20511)"><rect width="16" height="16" fill="#F2F3F7"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M8.00046 3.25C4.81864 3.25 2.08239 5.21352 1 8C2.08239 10.7865 4.81862 12.75 8.00046 12.75C11.1824 12.75 13.9195 10.7865 15.0009 8C13.9195 5.2135 11.1824 3.25 8.00046 3.25M8.00042 11.1664C6.21887 11.1664 4.8186 9.7738 4.8186 7.99999C4.8186 6.22621 6.21887 4.8336 8.00042 4.8336C9.78294 4.8336 11.1823 6.22621 11.1823 7.99999C11.1823 9.7738 9.78294 11.1664 8.00042 11.1664M8.00044 6.10003C6.91902 6.10003 6.09119 6.92383 6.09119 8C6.09119 9.07623 6.91902 9.9 8.00044 9.9C9.08283 9.9 9.90975 9.07621 9.90975 8C9.90975 6.92383 9.08283 6.10003 8.00044 6.10003" fill="#5587FF"></path></g><defs><clipPath id="clip0_1428_20511"><rect width="16" height="16" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var browseFilled = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { browseFilled as default };
